'use client';

import { ProductDocument } from 'models/product';
import BaseModal from '../../../components/modals/BaseModal';
import { UpdateBidForm } from '../forms/UpdateBidForm';

type PlaceABidModalProps = {
  product: ProductDocument;
  isOpen: boolean;
  dismiss: () => void;
  updateBidPrice: number;
};

export default function PlaceABidModal({
  product,
  isOpen,
  dismiss,
  updateBidPrice,
}: PlaceABidModalProps) {
  return (
    <>
      <BaseModal
        isOpen={isOpen}
        dismiss={() => {
          dismiss();
        }}
        className="w-[55rem]"
        title="Update Your Bid"
      >
        <UpdateBidForm
          product={product}
          onSubmitSuccess={() => dismiss()}
          updateBidPrice={updateBidPrice}
        />
      </BaseModal>
    </>
  );
}
